<template>
    <div>
        <yandex-map
        :settings="settings"
        :coords="coords"
        :zoom="zoom"
        :controls="controls"        
        @map-was-initialized="mapInit"
        
        >
        </yandex-map>
    </div>
</template>
<script>
import { yandexMap } from 'vue-yandex-maps'
import mapSettings from 'src/conf/yandexmap.js';

const defaultName='Станция метро'
const defaultColor='black'

export default {
    name: 'ReSubwayMapEditor',
    components: {
        yandexMap
    },
    data(){
        return {
            polygon: null,
            point: null,
            collection: null,
            map: null,
            current: false,
            // masCellOnMap: [],
        };
    },
    props:{
        /**
         * Объект с точкой станции метро и полигоном для него
         */
        value:{
            type: String,
            default:'{center:[59.93984485554249, 30.314527237792984],polygon:null}'
        },
        /**
         * Название станции метро
         */
        name: {
            type: String,
            default: defaultName,
        },
        /**
         * Название станции метро
         */
        color: {
            type: String,
            default: defaultColor,
        },
        /**
         * список дополнительных полигонов
         */
        stations:{
            type: Array,
            default(){ return []},
        },
        /**
         * Настройки карты
         */
        settings:{
            type: Object,
            default(){
                return {
                    ...mapSettings
                }
            },
        },
        /**
         * Координаты стартового центра карты
         */
		coords:{
            type: Array,
            default(){ return [59.93984485554249, 30.314527237792984]},
        },
        /**
         * величина зума (приближения) при её создании
         */

		zoom:{
            type: Number,
            default: 17,
        },
        /**
         * Список активных элементов в карте
         *  */        
		controls:{
            type: Array,
            default(){return ['zoomControl','typeSelector']},
        },
        /**
         * поле означающее что карта не будет редактироваться.
         *  */        
        readonly:{
            type: Boolean,
            default: false,
        }

    },
    watch:{
        value(newValue){
            let obj = this.getObjData();
            const current=JSON.stringify(obj);
            //console.log(newValue,current);
            if(current==newValue) // Не поменялось
                return;
            
            try{
                obj=JSON.parse(newValue)
                //points=JSON.parse(newValue);
            }catch(e){
                obj={};
            }
            //console.log(obj);
            if(obj.polygon){
                this.polygon.editor.geometry.setCoordinates(obj.polygon);
            }else{
                this.polygon.editor.geometry.setCoordinates([[]]);
            }
            if (obj.center) {
                // this.coords = obj.center;
                this.point.geometry.setCoordinates(obj.center);
                this.map.setCenter(obj.center);
            }
        },
        name(newValue) {
            if(this.point)
                this.point.properties.set('iconContent', newValue||defaultName);
        },
        color(newValue){
            if(this.point){
                this.point.options.set('preset', 'islands#' + (newValue || defaultColor) + 'StretchyIcon')
            }
        },
        stations(newValue){
            this.drawStations();
        }
    },
    methods:{
        /**
         * Включение режима редактирования.
         * center - логический, нужно ли центировать карту на редактируемом полигоне
         *  */ 
        startEdit(center){
            if(this.readonly) return false;
            setTimeout(()=>{
                this.polygon.editor.state.set('drawing',true);
                //this.point.geometry.setCoordinates(this.coords);
                //this.map.setCenter(this.coords);
            },1);
        },
        /**
         * центрирование карты на пришедшем полигоне
         * cellValues - текстовая строка с точками полигона.
         */
        focus(cellValues){
            try{
                let bounds;
                let polygon=JSON.parse(cellValues)
                if(polygon.length==1){ // 1 контур
                    polygon[0].forEach(coord=>{
                        if(!bounds)
                            bounds=[[...coord], [...coord]]
                        bounds=[
                            [
                                Math.min(bounds[0][0],coord[0]),
                                Math.min(bounds[0][1],coord[1]),
                            ],[
                                Math.max(bounds[1][0],coord[0]),
                                Math.max(bounds[1][1],coord[1]),
                            ]
                        ]
                    })
                    this.map.setBounds(bounds,{
                        duration:500,
                        zoomMargin:[100,500],
                    })                    
                }
            }catch(e){
                return false;
            }
        
        },
        /**
         * Зуммирует карту на редактируемом полигоне
         */
        zoomMap(){
            this.map.setBounds(this.polygon.editor.geometry.getBounds(),{
                duration:500,
                zoomMargin:[100,500],
            })
        },
        /**
         * перерисовка вторичныхполигонов на карте
         */
        drawStations(){
            if(!this.map) return;
            this.map.geoObjects.remove(this.collection);
            this.collection.removeAll();
            
            this.stations.forEach(station=>{
                try{
                    this.collection.add(new ymaps.GeoObject({
                        geometry: {
                            type: "Point",
                            coordinates: [station.latitude,station.longitude],
                        },
                        properties: {
                            iconContent: station.name,
                            balloonContent: station.name,
                            // balloonContent: 'Перемести меня'
                        }

                    },{
                        // Опции.
                        // Иконка метки будет растягиваться под размер ее содержимого.
                        // preset: 'islands#blackStretchyIcon',
                        // preset: 'islands#'+(station.color||'black')+'RapidTransitIcon',
                        preset: 'islands#'+(station.color || defaultColor)+'RapidTransitCircleIcon',
                        // Метку можно перемещать.
                        //draggable: true
                    }));

                    
                    this.collection.add(new ymaps.Polygon(
                        JSON.parse(station.value),
                        {
                            hintContent:station.id+': '+station.name,
                            balloonContentHeader:'Станция '+station.id,
                            balloonContentBody:station.name
                        },station.cellStyle||{
                            fillColor: '#00BF9A40',
                            // fillColor: '#00BF9A40',
                            strokeColor: '#0000FF',
                            strokeWidth: 1,
                        }
                    ));
                        // console.log(station.color);

                }catch(e){
                    console.error(e,station.value);
                }
            })

            this.map.geoObjects.add(this.collection);
        },
        /**
         * Возвращает объект для сохранения в моделе
         */

        getObjData(){
            return {
                center: this.point ? this.point.editor.geometry.getCoordinates() : null,
                polygon: this.polygon ? this.polygon.editor.geometry.getCoordinates() : null,
            }
        },
        /** 
         * принудительное обновление данных в моделе, по текущему полигону.
         */
        saveData(){
            if(this.polygon)
                this.$emit('input',JSON.stringify(this.getObjData()));
        },
        /**
         * инициализация карты после создания
         */
        mapInit(myMap){
            const me=this;
            this.map=myMap;
            var obj=JSON.parse(this.value)
            this.collection=new ymaps.GeoObjectCollection({},{});

            var point = new ymaps.GeoObject({
                geometry: {
                    type: "Point",
                    coordinates: obj.center||this.coords,
                },
                properties: {
                    iconContent: this.name || defaultName,
                    balloonContent: 'Перемести меня'
                }

            },{
                // Опции.
                // Иконка метки будет растягиваться под размер ее содержимого.
                preset: 'islands#'+(this.color||defaultColor)+'StretchyIcon',
                // Метку можно перемещать.
                draggable: true
            })
            this.point = point;

            var polygon = new ymaps.Polygon(obj.polygon, {
                
            }, {
                editorDrawingCursor: "crosshair",
                fillColor: '#00FF0040',
                strokeColor: '#0000FF',
                strokeWidth: 3,
               
            });
            this.polygon=polygon;
            if(!this.readonly){
                point.events.add(['dragend','vertexdragend','statechange','edgedragend'],(event)=>{
                    this.saveData();
                });
                polygon.editor.options.set('addInteriors',false);
                polygon.editor.options.set('menuManager',function(list,model){
                    list.push({
                        id:'clearAll',
                        title:'Очистить всё',
                        onClick(){
                            polygon.editor.geometry.setCoordinates([])
                            //me.value='[]';
                            me.startEdit();
                        }
                    })
                    return list;
                })
                polygon.editor.events.add(['vertexadd','vertexdraw','vertexdragend','statechange'],(event)=>{
                    this.saveData();
                });
                setTimeout(()=>polygon.editor.startDrawing(),10)
                
            }else{ 
                // console.log('READONLY');
            }

            myMap.geoObjects.add(polygon);
            myMap.geoObjects.add(point);

            this.drawStations();
        },

    },
    mounted() {
	}
}
</script>
